<!-- =========================================================================================
  File Name: SubscriptionSidebar.vue
  Description: Subscription details - Sidebar component
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal" @keyup.esc="esc()" >
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>{{$t('SUBSCRIPTION_DETAIL')}}</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <VuePerfectScrollbar class="scroll-area--data-list-add-new" :settings="settings">
      <div class="p-6">
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t("USER_ID")}}</small>
          <p class="font-semibold text-lg text-right">{{ user.userId }}</p>
        </div>
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t("SUBSCRIPTION_YN")}}</small>
           <p class="font-semibold text-lg text-right">{{$t(setInAppBillingStatusName(subscription.inAppBillingStatus))}} </p>
        </div>
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t("SUBSCRIPTION_CODE")}}</small>
          <p class="font-semibold text-lg text-right">{{ $t(setSubscriptionCodeName(subscription.subscriptionCode)) }}</p>
        </div>
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t("LAST_BILLING_DATE")}}</small>
          <p class="font-semibold text-lg text-right">{{ setDate(subscription.lastBillingDate) }}</p>
        </div>
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t("EXPIRATION_DATE")}}</small>
          <p class="font-semibold text-lg text-right">{{ setDate(subscription.expirationDate) }}</p>
        </div>
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t("TERMINATION_DATE")}}</small>
          <p class="font-semibold text-lg text-right">{{ setDate(subscription.terminationDate) }}</p>
        </div>
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t("STORAGE_QUOTA")}} 
          </small>
          <p  class="font-semibold text-lg text-right"> {{ subscription.storageQuota.toLocaleString() }} MB </p>
        </div>
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t("USED_STORAGE")}} </small>
          <p class="font-semibold text-lg text-right"> {{ subscription.usedStorage.toLocaleString() }} MB </p>
        </div>
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t("STREAMING_QUOTA_TIME")}} </small>
          <p class="font-semibold text-lg text-right"> {{ subscription.streamingQuotaTime.toLocaleString() }} {{$t('MINUTE')}} </p>
        </div>
        <div class="vx-col w-full sm:w-auto detail-list">
          <small>{{$t("USED_STREAMING_TIME")}}
            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData('USED_STREAMING_TIME', subscription.usedStreamingTime)" class="edit-icon" /> 
          </small>
          <p  class="font-semibold text-lg text-right"> {{ subscription.usedStreamingTime.toLocaleString() }} {{$t('MINUTE')}} </p>
        </div>
        <div class="vx-col w-full sm:w-auto detail-list" v-if="subscription.useDataTrafficYn==='Y'">
          <small>{{$t("UPLOAD_TRAFFIC_QUOTA")}}</small>
          <p class="font-semibold text-lg text-right"> {{ subscription.uploadTrafficQuota.toLocaleString() }} MB </p>
        </div>
        <div class="vx-col w-full sm:w-auto detail-list" v-if="subscription.useDataTrafficYn==='Y'">
          <small>{{$t("UPLOAD_USED_TRAFFIC")}}
            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData('UPLOAD_USED_TRAFFIC', subscription.uploadUsedTraffic)" class="edit-icon" /> 
          </small>
          <p class="font-semibold text-lg text-right"> {{ subscription.uploadUsedTraffic.toLocaleString() }} MB </p>
        </div>
        <div class="vx-col w-full sm:w-auto detail-list" v-if="subscription.useDataTrafficYn==='Y'">
          <small>{{$t("DOWNLOAD_TRAFFIC_QUOTA")}}</small>
          <p class="font-semibold text-lg text-right"> {{ subscription.downloadTrafficQuota.toLocaleString() }} MB </p>
        </div>
        <div class="vx-col w-full sm:w-auto detail-list" v-if="subscription.useDataTrafficYn==='Y'">
          <small>{{$t("DOWNLOAD_USED_TRAFFIC")}}
            <feather-icon icon="EditIcon" svgClasses="w-5 h-5 hover:text-primary stroke-current" @click.stop="editData('DOWNLOAD_USED_TRAFFIC', subscription.downloadUsedTraffic)" class="edit-icon" /> 
          </small>
          <p class="font-semibold text-lg text-right"> {{ subscription.downloadUsedTraffic.toLocaleString() }} MB </p>
        </div>
      </div>
    </VuePerfectScrollbar>

    <vs-popup class="sidebar-popup" classContent="popup-example" :title="setPromptTitle(changeOption)" :active.sync="editPopup">
      <div>
        <vs-input :label="$t(changeOption)" v-model="changeData" class="mt-5 w-full" name="change" v-validate="{required: true}" icon-pack="feather" v-mask="'##'" />
			</div>
      <vs-divider />
      <div class="float-right">
        <vs-button @click="openConfirm()" color="primary" type="filled">{{this.$t('SUBMIT')}}</vs-button>
        <vs-button @click="editPopup=false" color="dark" type="flat">{{this.$t('CANCEL')}}</vs-button>
      </div>

      <vs-popup class="sidebar-popup"  :title="this.$t('CONFIRM')" :active.sync="confirmPopup">
        <p>{{this.$t('SUBMIT_CONFIRM_MESSAGE')}}</p>
        <div class="float-right">
            <vs-button @click="acceptEdit()" color="danger" type="filled">{{this.$t('CONFIRM')}}</vs-button>
            <vs-button @click="confirmPopup=false" color="dark" type="flat">{{this.$t('CANCEL')}}</vs-button>
        </div>
      </vs-popup>
    </vs-popup>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-5" type="border" color="danger" @click="isSidebarActiveLocal = false">{{$t('CLOSE')}}</vs-button>
    </div>

  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'

export default {
  components: {
    VuePerfectScrollbar,
  },
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true
    },
    data: {
      type: Object,
      default: () => {},
    }
  },
  watch: {
    isSidebarActive(val) {
      if (!val) return
      let { user, subscription } = JSON.parse(JSON.stringify(this.data))
      this.user = user
      this.subscription = subscription
      this.$validator.reset()
    },
  },
  data() {
    return {

      editPopup: false,
      confirmPopup: false,

      user:{
        userId: "",
      },
      subscription:{
        inAppBillingStatus: "",
        subscriptionCode: "",
        usedStorage: "",
        storageQuota: "",
        lastBillingDate: "",
        usedStreamingTime: "",
        streamingQuotaTime: "",
        useDataTrafficYn: "",
        uploadTrafficQuota: "",
        uploadUsedTraffic: "",
        downloadTrafficQuota: "",
        downloadUsedTraffic: "",
        userUUID: ""
      },

      changeOption: "",
      changeData: "",

      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60,
      },
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive
      },
      set(val) {
        if (!val) {
          this.$emit('closeSidebar')
        }
      }
    },
    isFormValid() {
        return !this.errors.any()
    },
  },
  methods: {
    setInAppBillingStatusName(status){
      if (!status) return ""
      return this.$store.state.commonConfig.inAppBillingStatus.properties[status].name
    },
    setSubscriptionCodeName(status){
      if (!status) return ""
      return this.$store.state.commonConfig.subscriptionCode.properties[status].name
    },
    setDate(date){
      if(!date){
        return '-'
      }else {
        let localTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone
        let dateTime = this.$moment(date,'YYYYMMDDHHmmss').format()
        let dateTimeToLocal = this.$moment.tz(dateTime, localTimeZone).format('YYYY-MM-DD')
          
        return dateTimeToLocal
      }
      
    },
    setPromptTitle(changeOption){
      const locale = this.$i18n.locale;
      if(locale == 'en'){
        return 'EDIT '+this.$t(changeOption)
      } else if (locale == 'ko') {
        return this.$t(changeOption)+' 수정'
      }
    },
    editData(option, data){
      this.changeOption = option
      this.changeData = data
      this.editPopup = true
    },
    openConfirm() {
      this.confirmPopup = true
    },
    acceptEdit(){
      this.$vs.loading()

      const obj = {
        userUUID: this.subscription.userUUID,
        changeOption: this.changeOption,
        changeData: this.changeData
      }
    
      this.$store.dispatch("dataSubscription/updateSubscription", obj)
      .then(() => {
        this.close()
        this.successAlert(this.$t("SUCCESS"),this.$t("UPDATE_SUBSCRIPTION_SUCCESS"))
        this.$parent.$refs.subscriptionTable.getData()
      })
      .catch(error => {
        this.close()
        this.errorAlert(this.$t("ERROR"), error.message)
      })
    },
    close(){
      this.confirmPopup = false
      this.editPopup = false
      this.$vs.loading.close()
      this.$emit('closeSidebar')
    }
  },
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52004;
  }

  ::v-deep .vs-sidebar {
    z-index: 52004;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    height: calc(100% - 4.3rem);
}

.detail-list{
  border-bottom:1px solid rgba(0, 0, 0, 0.1);
  padding: 5px 0;
}


.edit-icon svg{
  padding-top: 3px !important;
}


</style>
